export enum RevenueStructuresRoutes {
  CreateOne = 'create-one',
  Search = 'search',
  UpdateOne = 'update-one',
}
